import { version } from '../../package.json';
export const environment = {
  production: false,
  name: 'Homologação',
  url: 'https://sitewindows.azurewebsites.net',
  home: 'https://sitewindows.azurewebsites.net',
  domain: 'https://sitewindows.azurewebsites.net',
  system_version: version,
  mobileUrl: 'https://sitewindows.azurewebsites.net',
  apiUrl: 'https://sitewindows.azurewebsites.net/api',
  rdBaseUrl: 'https://api.rd.services',
  rdstationClientId : '27bb4fe5-1c3c-4c3d-9d49-568a7472ee12',
  rdstationClienteSecret : '518be3c4cd844b6d8e6cab393af0f1fc',
  rdstationStartCode : '343fb183efde86b7c427e9e2da242ccb',
  rdstationRefreshCode : '6Rs9OOgNAQwVUqO4Kk1S-3BxGQkx31jGSyNahL01UbQ',
  salesTokenUrl : 'https://montrealviagens--staging.sandbox.my.salesforce.com/services/oauth2/token',
  salesClientId: '3MVG9hPGCoG2ZiCvn8VzMjBqbP82nSaxNlKIP0ja42_0mGyQPdaPWXlUrvEKesZIg.z3A0c_3i4NjpgOzhRpX',
  salesClientSecret: '4A0CBE45265809AF4D7B0869DED6A1554BA097FB5944485E537532FA527C345F',
  salesUsername: 'integracao@viagensmontreal.com.staging',
  salesPassword: 'aR6GtSg8@MontreaLhRB2K9XLZCnO3MdhR1xoQ3bBM',
  salesServiceData: 'https:///montrealviagens--staging.sandbox.my.salesforce.com/services/data/v53.0',
  // salesServiceRest: 'https://montrealviagens--staging.sandbox.my.salesforce.com/services/apexrest/montreal',
  salesServiceRest: 'https://proxy-hm.azurewebsites.net',
  idPriceBook: '01s4x000007IXQ1AAO',
  paginaPagamento: 'https://montrealviagens--staging.sandbox.my.site.com/aceite/s/',
  // tslint:disable-next-line:max-line-length
  salesBase: 'https://montrealviagens--staging.sandbox.my.salesforce.com/services/oauth2/token?username=integracao%40viagensmontreal.com.staging&password=Integ!%40%23Montreal!%3D986nT5qrJp0lcGvhFqjCrmwjg9vR&grant_type=password&client_id=3MVG96WMoUG6yB9IfJryrZnRV.ooPYvZL0cUCvHNWoHZZMMfSdD2sp.OUoJ3yK6jzJaYyoFe2f9SC10Wu4Vjl&client_secret=ADBDE617186E6D4C418BFE89206069C14CFB8CCC2445F5449CB8E1E04772316F',
  salesUrl: 'https://montrealviagens--staging.sandbox.my.site.com',
  // salesUrl: 'https://proxy-hm.azurewebsites.net',
  authSalesApi: 'https://montrealviagens--staging.sandbox.my.salesforce-sites.com/PushWebhook/services/apexrest/obterToken/',
};
